import { useEffect, useRef, memo } from 'react';

const CanvasGold = () => {
  const ref = useRef(null);

  useEffect(() => {
    let fps = 30;
    let now;
    let then = Date.now();
    let interval = 1000 / fps;
    let delta;

    // canvas init
    let canvas = ref.current;
    let ctx = canvas.getContext('2d');

    // canvas dimensions
    let W = window.innerWidth;
    let H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;

    // snowflake particles
    let mp = 360; // max particles
    let particles = [];
    for (let i = 0; i < mp; i++) {
      particles.push({
        x: Math.random() * W, // x-coordinate
        y: Math.random() * H, // y-coordinate
        r: Math.random() * 4 + 1, // radius
        // d: Math.random() * mp // random density
        d: mp, // density
      });
    }

    let pArr = [];
    for (let xx = 0; xx < 10; xx++) {
      let _img = new Image();
      _img.src = `//blcdnsmall.nikkigames.cn/sdk/poster/evolweb/secondary/particles/${xx + 1}.png`;
      pArr.push(_img);
    }

    // angle will be an ongoing incremental flag.
    // Sin and Cos functions will be applied to it to create vertical and horizontal movements of the flakes
    let angle = 0;

    // Function to move the snowflakes
    function update() {
      angle += 0.02;
      for (let i = 0; i < mp; i++) {
        let p = particles[i];
        // Updating X and Y coordinates
        // We will add 1 to the cos function to prevent negative values which will lead flakes to move upwards
        // Every particle has its own density which can be used to make the downward movement different for each flake
        // Lets make it more random by adding in the radius
        p.y += Math.cos(angle + p.d) + 1.5 + p.r / 2;
        p.x += Math.sin(angle) * 2;

        // Sending flakes back from the top when it exits
        // Lets make it a bit more organic and let flakes enter from the left and right also.
        if (p.x > W + 5 || p.x < -5 || p.y > H) {
          // 66.67% of the flakes
          if (i % 3 > 0) {
            particles[i] = { x: Math.random() * W, y: -10, r: p.r, d: p.d };
          } else if (Math.sin(angle) > 0) {
            // If the flake is exitting from the right
            // Enter from the left
            particles[i] = { x: -5, y: Math.random() * H, r: p.r, d: p.d };
          } else {
            // Enter from the right
            particles[i] = { x: W + 5, y: Math.random() * H, r: p.r, d: p.d };
          }
        }
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);

      for (let i = 0; i < mp; i++) {
        let p = particles[i];
        let img = pArr[Math.floor((p.r - 1) * 2.5)];
        ctx.drawImage(img, p.x, p.y, img.width * 0.16, img.height * 0.16);
      }
      // 计算下一次移动位置
      update();
    }

    function tick() {
      requestAnimationFrame(tick);
      now = Date.now();
      delta = now - then;
      if (delta > interval) {
        // 这里不能简单then=now，否则还会出现上边简单做法的细微时间差问题。
        // 例如fps=10，每帧100ms，而现在每16ms（60fps）执行一次draw。16*7=112>100，需要7次才实际绘制一次。这个情况下，实际10帧需要112*10=1120ms>1000ms才绘制完成。
        then = now - (delta % interval);
        draw(); // ... Code for Drawing the Frame ...
      }
    }
    tick();
  }, []);

  return (
    <div style={{ position: 'absolute', pointerEvents: 'none' }}>
      <canvas ref={ref} />
    </div>
  );
};

export default memo(CanvasGold);
